import { render, staticRenderFns } from "./AccordionParser.vue?vue&type=template&id=715f6ac0"
import script from "./AccordionParser.vue?vue&type=script&lang=js"
export * from "./AccordionParser.vue?vue&type=script&lang=js"
import style0 from "./AccordionParser.vue?vue&type=style&index=0&id=715f6ac0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports